import PropertyDetails from "@/components/ReviewApplication/PropertyDetails";
import { ApplicationDto } from "@/lib/DTMWebAPIClient.generated";
import { createApiClient } from "@/lib/Requests";
import { setClickInsightEvents } from "@/lib/util";
import { setApplicationProgress } from "@/slices/applicationSlice";
import { selectCurrentEmployment } from "@/slices/currentEmploymentSlice";
import { selectHomeAddress } from "@/slices/homeAddressSlice";
import { selectPreviousAddress } from "@/slices/PreviousAddressSlice";
import { selectPreviousEmployment } from "@/slices/previousEmploymentSlice";
import { setCoapplicantComplete, setProfileComplete } from "@/slices/progressSlice";
import { RootState } from "@/store/dtm";
import SlideTransition from "@/styles/animation/SlideTransition";
import style from "@/styles/pages/ReviewApplication/ReviewApplication.module.css";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function JointPropertyDetails() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const credential = useSelector(
        (state: RootState) => state.credential
    );
    const client = createApiClient({ timeout: 60000, token: credential.credential.accessToken });

    const application = useSelector(
        (state: RootState) => state.application.application
    );
    const applicant = useSelector(
        (state: RootState) => state.applicant.applicant
    );
    const homeAddress = useSelector(selectHomeAddress);
    const previousAddresses = useSelector(selectPreviousAddress).addresses;
    const currentEmployment = useSelector(selectCurrentEmployment).employments;
    const previousEmployment = useSelector(selectPreviousEmployment);
    const referralProducts = useSelector((state: RootState) => state.referralProducts.products);

    function handleClick() {
        dispatch(setApplicationProgress(14));
        navigate("/joint/review-application");
    }

    useEffect(() => {
        document.title = "Review property details";

        setClickInsightEvents(referralProducts, undefined, undefined, undefined, undefined, application.id, applicant);
        dispatch(setCoapplicantComplete(true));
        dispatch(setProfileComplete(true));

        client.apiApplicationsFetch().then((result) => {
            result.application = application;
            result.previousAddresses = previousAddresses;
            result.homeAddress = homeAddress.address;
            result.currentEmployment = currentEmployment;
            result.previousEmployment = previousEmployment;
            client.apiApplicationsSave(new ApplicationDto({
                applicationData: JSON.stringify(result)
            })).catch((error) => {
                console.log("Error saving application info");
            });
        }).catch((error) => {
            console.log("Error fetching application info");
        });
    }, []);

    return (
        <SlideTransition>
            <main aria-labelledby="main-content">
                <div className="flex flex-col max-xs:px-3 sm:ml-80 max-md:items-center max-md:mt-20">
                    <div
                        className={style.addHeading}
                        role="region"
                        aria-label="Address Header"
                    >
                        <div className={style.raHeading}>
                            <h1>Your property details</h1>
                            <p className="sub-heading">
                                These are the details {application.jointPrimaryApplicant != "" ? application.jointPrimaryApplicant : "your primary applicant"} has provided for your mortgage.
                            </p>
                            <div className={style.sectionContainer}>
                                <hr className="mt-5" />
                                <PropertyDetails editModeOn={false} restrictEditing={true} />
                                <hr className="mt-5" />
                            </div>
                        </div>
                        <div className="flex max-sm:hidden">
                            <div className="mb-5 mr-5">
                                <button onClick={() => navigate(-1)}
                                    type="button"
                                    className="back mt-5 w-169 sm:w-28 h-11 px-6">
                                    Back
                                </button>
                            </div>
                            <div className="mb-5">
                                <button
                                    type="submit"
                                    onClick={handleClick}
                                    className="primary mt-5 w-full sm:w-28 h-11 px-6"
                                >
                                    Continue
                                </button>
                            </div>
                        </div>
                        <div className="sm:hidden">
                            <div className="mb-5">
                                <button
                                    type="submit"
                                    onClick={handleClick}
                                    className="primary mt-5 w-full sm:w-28 h-11 px-6"
                                >
                                    Continue
                                </button>
                            </div>
                            <div className="mb-5">
                                <button onClick={() => navigate(-1)}
                                    type="button"
                                    className="back mt-5 w-full sm:w-28 h-11 px-6">
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </SlideTransition>
    );
}